import { NgModule, Component, OnInit, ViewChild, ElementRef, PipeTransform, ViewContainerRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import {Pipe} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { HTTPService } from '../Services/http.service';
import { HttpModule } from '@angular/http';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DomSanitizer,SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Input } from '@angular/core';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'common-popup',
  templateUrl: './AppViews/ReviewEmployee/PopUp.html',
  providers: [HTTPService]
})
export class PopupComponent implements OnInit {
  
  safeDocUrl : SafeUrl;

  //drivePath = "../../assets/img/nocontent.png";
  
  docName :any;
  docItem =  {
      DocName: null,
      FolderPath: null
    }

    imageType: any; 

    isInitData = false; 



  constructor(public sanitizer: DomSanitizer) {

  }


  ngOnInit(): void {
  // this.safeDocUrl = this.sanitizer.bypassSecurityTrustResourceUrl("../../assets/img/nocontent.png");
  }

  ngAfterViewInit() {
   
  }

  showDoc(item){
    
    this.isInitData = true;

    this.imageType = null;
    this.docItem.DocName = null;
    // this.docItem.FolderPath = "../../assets/img/nocontent.png";
    // this.drivePath = "../../assets/img/nocontent.png";

    if(item != null){
      this.docItem = JSON.parse(JSON.stringify(item));

   if(this.docItem.FolderPath == null || this.docItem.FolderPath == ""){
    // this.docItem.FolderPath = "../../assets/img/nocontent.png";
   }

      this.getFileType();
      this.docName = item.DocName;
    }
  }

  getFileType(){
    
    if(this.docItem.DocName != null && this.docItem.DocName != ""){
      var iName = this.docItem.DocName.split(".");
      if(iName.length > 0 && iName.length - 1 != null)
       this.imageType = iName[iName.length - 1].toLowerCase();
    }


    
    if(this.imageType != 'jpg' && this.imageType != 'png' && this.imageType != 'jpeg' && this.imageType != 'msg'){
      var docpath = "https://docs.google.com/viewer?url=" + this.docItem.FolderPath+"&embedded=true";
     //  var docpath = this.docItem.FolderPath;
        

       var safeUrl =  this.sanitizer.bypassSecurityTrustResourceUrl(JSON.parse(JSON.stringify(docpath)));

       this.safeDocUrl =  safeUrl;

    }else{

    }


  }

}


/** WEBPACK FOOTER **
 ** ./TypeScripts/ReviewEmployee/PopUp.component.ts
 **/